export type CloudProductKey = "mmc" | "mcc" | "msc";

export type ProductPlanSnapshot = Record<CloudProductKey, string>;

type PreviousProductPlansState = {
  accountId: string;
  plans: ProductPlanSnapshot;
};

let previousProductPlans: PreviousProductPlansState | null = null;

export function setPreviousProductPlans(
  accountId: number | string,
  plans: ProductPlanSnapshot
): void {
  previousProductPlans = {
    accountId: String(accountId),
    plans,
  };
}

/** Returns plans only when they belong to the same account. */
export function getPreviousProductPlans(
  accountId: number | string
): ProductPlanSnapshot | null {
  if (!previousProductPlans) return null;
  if (previousProductPlans.accountId !== String(accountId)) return null;
  return previousProductPlans.plans;
}
